import { render, staticRenderFns } from "./ImpostazioniApp.vue?vue&type=template&id=62c5ba7f&scoped=true"
import script from "./ImpostazioniApp.vue?vue&type=script&lang=js"
export * from "./ImpostazioniApp.vue?vue&type=script&lang=js"
import style0 from "./ImpostazioniApp.vue?vue&type=style&index=0&id=62c5ba7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c5ba7f",
  null
  
)

export default component.exports